import {
  Tabs,
  TabPanels,
  TabPanel,
  TabList,
  useMediaQuery,
  Tab,
} from "@chakra-ui/react";
import ExternalSourceTable from "../../components/tables/ExternalSourceTable";
import UsersTable from "../../components/tables/UsersTable";
import AdminLayout from "../../layout/AdminLayout";

type AdminPageContainerProps = {};

const AdminPageContainer = (props: AdminPageContainerProps) => {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <AdminLayout>
      <Tabs variant="enclosed" isFitted={!isLargerThan900} p="2">
        <TabList>
          <Tab _selected={{ color: "white", bg: "primary" }}>Users</Tab>
          <Tab _selected={{ color: "white", bg: "primary" }}>
            External Sources
          </Tab>
          {/* <Tab _selected={{ color: "white", bg: "primary" }}>Requests</Tab> */}
        </TabList>
        <TabPanels>
          <TabPanel>
            <UsersTable />
          </TabPanel>
          <TabPanel>
            <ExternalSourceTable />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </AdminLayout>
  );
};

export default AdminPageContainer;
